export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGIN_DATA_CLEAR = 'LOGIN_DATA_CLEAR';



export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';

export const ACHIEVE_SIGNUP_BONUS = 'ACHIEVE_SIGNUP_BONUS';
export const ACHIEVE_DAILY_REWARD = 'ACHIEVE_DAILY_REWARD';

export const EDIT_PROFILE_REQUEST = 'EDIT_PROFILE_REQUEST';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAILURE = 'EDIT_PROFILE_FAILURE';

export const CONFIGDATA_REQUEST = 'CONFIGDATA_REQUEST';
export const CONFIGDATA_SUCCESS = 'CONFIGDATA_SUCCESS';
export const CONFIGDATA_FAILURE = 'CONFIGDATA_FAILURE';

export const LESSON_ID_REQUEST = 'LESSON_ID_REQUEST';
export const LESSON_ID_SUCCESS = 'LESSON_ID_SUCCESS';
export const LESSON_ID_FAILURE = 'LESSON_ID_FAILURE';

export const TOPIC_ID_REQUEST = 'TOPIC_ID_REQUEST';
export const TOPIC_ID_SUCCESS = 'TOPIC_ID_SUCCESS';
export const TOPIC_ID_FAILURE = 'TOPIC_ID_FAILURE';


export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';

export const GET_AVATAR_REQUEST = 'GET_AVATAR_REQUEST';
export const GET_AVATAR_SUCCESS = 'GET_AVATAR_SUCCESS';
export const GET_AVATAR_FAILURE = 'GET_AVATAR_FAILURE';


export const VERIFY_OTP = 'VERIFY_OTP';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILURE = 'VERIFY_OTP_FAILURE';

export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE';

export const SEND_OTP_REQUEST = 'SEND_OTP_REQUEST';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_FAILURE = 'SEND_OTP_FAILURE';

export const TOASTMESSAGE_DATA = "TOASTMESSAGE_DATA";
export const TOASTMESSAGE_DATA_CLEAR = "TOASTMESSAGE_DATA_CLEAR";

export const PAYMENT = "PAYMENT";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
export const PAYMENT_FAILURE = "PAYMENT_FAILURE";

export const RAKUTEN_LIST = "RAKUTEN_LIST";
export const RAKUTEN_LIST_SUCCESS = "RAKUTEN_LIST_SUCCESS";
export const RAKUTEN_LIST_FAILURE = "RAKUTEN_LIST_FAILURE";
